import script from "./WageExcelBeforeAfter.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageExcelBeforeAfter.vue?vue&type=script&setup=true&lang=ts"

import "./WageExcelBeforeAfter.vue?vue&type=style&index=0&id=b12e0b6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b12e0b6c"]])

export default __exports__